// src/hooks/useAuth.ts
import { useContext } from 'react';
import { ShopAuthContext } from '../context/ShopAuthContext';
import { AdminAuthContext } from '../admin/context/AdminAuthContext';
import { ShopAuthContextType, AdminAuthContextType } from '../types/auth';

export const useFrontendAuth = (): ShopAuthContextType => {
    const context = useContext(ShopAuthContext);
    return context;
};
export const useBackendAuth = (): AdminAuthContextType => {
    const context = useContext(AdminAuthContext);
    if (!context) {
        throw new Error('useBackendAuth must be used within an AuthProvider');
    }
    return context;
};